import styles from "./style.module.less";

const OrderNoteCount = ({ count }) => (
  <div className={count ? styles.filled : styles.empty}>{count}</div>
);

export default OrderNoteCount;
